var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCollapse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Collapse",
    transform: "translate(-604 121)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_8568",
    "data-name": "Rectangle 8568",
    width: 36,
    height: 36,
    transform: "translate(604 -121)",
    fill: "#fff",
    opacity: 0
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_19261",
    "data-name": "Group 19261",
    transform: "translate(5.059 -1.941)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8558",
    "data-name": "Rectangle 8558",
    transform: "translate(607.941 -110.059)",
    fill: "#313131",
    stroke: "#f5f5f5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 14.5,
    height: 14.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8560",
    "data-name": "Rectangle 8560",
    transform: "translate(614.941 -103.059)",
    stroke: "#313131",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 9,
    height: 9,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_8559",
    "data-name": "Rectangle 8559",
    transform: "translate(615.941 -102.059)",
    fill: "#313131",
    stroke: "#f5f5f5",
    strokeWidth: 1.5
  }, /*#__PURE__*/React.createElement("rect", {
    width: 8,
    height: 8,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.75,
    y: 0.75,
    width: 6.5,
    height: 6.5,
    fill: "none"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapse);
export default __webpack_public_path__ + "static/media/Collapse.8b4c962b4651b6863cc307d1c3b67914.svg";
export { ForwardRef as ReactComponent };